// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  fbToken : "EAAJG4h7KA5kBAPxQT80YfsG2ZAQthhJazXbZCzrhxDpw6eZAuBXSueCl9VZCqh76FdJgC7aNpnUI2aU7AFCqUL11KZBWy0uozs1SE5JH0scQSM8ZCm6hzzcfMZC7TTaNd4px7XK3FGWSSYhmxxa6gDgKENiM3SaX4KdoZAALTifa1QZDZD",
  host: "https://admin.blush-sd.com/api/"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
